// 权重组卷
import { request } from "@/utils/request";

//  权重组卷 - 获取试卷提醒样式(范围)
export const getPaperStyle = data => {
  return request({
    method: "POST",
    url: "/api/ProportionPaper/getPaperStyle/getPaperStyle",
    data
  });
};
 
